<template>
  <div class="mt-4">
    <h2 class="mb-4">{{ $t('Payment.subscription.header') }}</h2>
    <p>{{ $t('Payment.subscription.content') }}</p>

    <ValidationProvider v-slot="subscriptionCheck" name="subscription confirmation" mode="lazy">
      <b-form-group id="input-group-subscription-check" class="mb-1" label-for="input-subscription-check">
        <b-form-checkbox
          :id="`input-subscription-check-${id}`"
          v-model="isSubscribed"
          :state="getValidationState(subscriptionCheck)"
          aria-describedby="input-subscription-check-feedback"
          :unchecked-value="null"
          @change="emitSubscriptionChange"
        >
          <p class="mb-1">{{ $t('Payment.subscription.checkbox1') }}</p>
          <p class="disclaimer">
            {{ $t('Payment.subscription.checkbox1Disclaimer') }}
          </p>
        </b-form-checkbox>

        <b-form-invalid-feedback id="input-subscription-check-feedback">
          {{ subscriptionCheck.errors[0] }}
        </b-form-invalid-feedback>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

interface Flags {
  [k: string]: boolean | null;
}

interface Customer {
  isSubscribed: boolean | null;
}

export default Vue.extend({
  name: 'SubscriptionCheck',
  props: {
    customer: {
      type: Object as PropType<Customer>,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isSubscribed: this.customer.isSubscribed
    };
  },
  watch: {
    'customer.isSubscribed': {
      immediate: true,
      handler(newValue) {
        this.isSubscribed = newValue;
      }
    }
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }: Flags) {
      if (!this.isSubscribed) return null;
      return dirty || validated ? valid : null;
    },
    emitSubscriptionChange(value: boolean | null) {
      this.$emit('update:isSubscribed', value);
    }
  }
});
</script>

<style scoped lang="scss">
.disclaimer {
  color: #767676;
  font-size: 14px;
  line-height: 1.2;
}
</style>
